import React from 'react';
import Session from "../helpers/Session";

class User extends React.Component {

    render() {
        const user = Session.getLogin();

        if (user) {
            return (
                <span className='nombre-usuario'>{user.terceroNombre1} {user.terceroNombre2} {user.terceroApellido1} {user.terceroApellido2}</span>
            );
        } else {
            return (null);
        }

    }
}

export default User